import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

/**
 * * Diretiva para redimensionamento de um elemento <textarea></textarea>.
 */
@Directive({
  selector: '[textAreaVerticalResize]'
})
export class TaVerticalResizeDirective implements OnInit {
  // O Objetivo dessa diretriz é permitir que uma textarea aumente e diminua seu tamanho máximo com responsividades.
  // Ao alcançar o tamanho máximo, uma scrollbar aparecerá.

  /**
   * * Valor da Altura Máxima.
   */
  @Input() alturaMaxima: string = '200px';
  /**
   * * Valor da Altura Mínima.
   */
  @Input() alturaMinima: string = '70px';

  @HostListener('keyup', ['$event'])
  handleInputChange($event: Event) {
    let textarea = this.elRef.nativeElement as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    let scHeight = textarea.scrollHeight + 2; // +2 garante que não teremos uma scrollbar mesmo com o texto estando 100% visível.
    textarea.style.height = `${scHeight}px`
  }

  ngOnInit(): void {
      this.elRef.nativeElement.style.maxHeight = `${this.alturaMaxima}`
      this.elRef.nativeElement.style.minHeight = `${this.alturaMinima}`
  }

  constructor(private elRef: ElementRef) { }

}
